/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EStatutDemande } from './EStatutDemande';
import {
    EStatutDemandeFromJSON,
    EStatutDemandeFromJSONTyped,
    EStatutDemandeToJSON,
} from './EStatutDemande';

/**
 * 
 * @export
 * @interface StatutDemandeCodeIdDto
 */
export interface StatutDemandeCodeIdDto {
    /**
     * 
     * @type {number}
     * @memberof StatutDemandeCodeIdDto
     */
    idstatutDemande?: number;
    /**
     * 
     * @type {EStatutDemande}
     * @memberof StatutDemandeCodeIdDto
     */
    code?: EStatutDemande;
}

/**
 * Check if a given object implements the StatutDemandeCodeIdDto interface.
 */
export function instanceOfStatutDemandeCodeIdDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StatutDemandeCodeIdDtoFromJSON(json: any): StatutDemandeCodeIdDto {
    return StatutDemandeCodeIdDtoFromJSONTyped(json, false);
}

export function StatutDemandeCodeIdDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatutDemandeCodeIdDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idstatutDemande': !exists(json, 'idstatutDemande') ? undefined : json['idstatutDemande'],
        'code': !exists(json, 'code') ? undefined : EStatutDemandeFromJSON(json['code']),
    };
}

export function StatutDemandeCodeIdDtoToJSON(value?: StatutDemandeCodeIdDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idstatutDemande': value.idstatutDemande,
        'code': EStatutDemandeToJSON(value.code),
    };
}

